export const Month = {
  January: 1,
  February: 2,
  March: 3,
  April: 4,
  May: 5,
  June: 6,
  July: 7,
  August: 8,
  September: 9,
  October: 10,
  November: 11,
  December: 12,
};

export const getMonthNameFromNumber = (monthNumber: any) => {
  if (localStorage.getItem("lan") === "english") {
    switch (monthNumber) {
      case Month.January:
        return "January";
      case Month.February:
        return "February";
      case Month.March:
        return "March";
      case Month.April:
        return "April";
      case Month.May:
        return "May";
      case Month.June:
        return "June";
      case Month.July:
        return "July";
      case Month.August:
        return "August";
      case Month.September:
        return "September";
      case Month.October:
        return "October";
      case Month.November:
        return "November";
      case Month.December:
        return "December";
      default:
        return "Invalid Month";
    }
  } else {
    switch (monthNumber) {
      case Month.January:
        return "जनवरी";
      case Month.February:
        return "फरवरी";
      case Month.March:
        return "मार्च";
      case Month.April:
        return "अप्रैल";
      case Month.May:
        return "मई";
      case Month.June:
        return "जून";
      case Month.July:
        return "जुलाई";
      case Month.August:
        return "अगस्त";
      case Month.September:
        return "सितंबर";
      case Month.October:
        return "अक्टूबर";
      case Month.November:
        return "नवंबर";
      case Month.December:
        return "दिसंबर";
      default:
        return "Invalid Month";
    }
  }
}; 